export const ProofIncluded = Object.freeze({
    NotSet: 0,
    Supplied: 3000,
    Request: 3001,
    None: 3002,
    Virtual: 3003,
    RequestPublisher: 3004
});